import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'
import { useAuth } from '../../../hooks/useAuth'
import './Navigation.css'

function Navigation() {
  const { t } = useTranslation()
  const location = useLocation()
  const { isAuthenticated, login, logout } = useAuth()
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const isLandingPage = location.pathname === '/'
  const isDocsPage = location.pathname.startsWith('/docs')

  useEffect(() => {
    setIsMobileMenuOpen(false)
  }, [location.pathname])

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false)
  }

  const renderDocsMenu = () => (
    <>
      <li>
        <Link to='/' onClick={closeMobileMenu}>
          {t('nav.home')}
        </Link>
      </li>
      <li>
        <Link to='/docs' onClick={closeMobileMenu}>
          {t('nav.documentation')}
        </Link>
      </li>
    </>
  )

  const renderLandingMenu = () => (
    <>
      <li>
        {isLandingPage ? (
          <a href='#features' onClick={closeMobileMenu}>
            {t('nav.features')}
          </a>
        ) : (
          <Link to='/#features' onClick={closeMobileMenu}>
            {t('nav.features')}
          </Link>
        )}
      </li>
      <li>
        {isLandingPage ? (
          <a href='#pricing' onClick={closeMobileMenu}>
            {t('nav.pricing')}
          </a>
        ) : (
          <Link to='/#pricing' onClick={closeMobileMenu}>
            {t('nav.pricing')}
          </Link>
        )}
      </li>
      <li>
        <Link to='/docs' onClick={closeMobileMenu}>
          {t('nav.docs')}
        </Link>
      </li>
      <li>
        {isLandingPage ? (
          <a href='#about' onClick={closeMobileMenu}>
            {t('nav.about')}
          </a>
        ) : (
          <Link to='/#about' onClick={closeMobileMenu}>
            {t('nav.about')}
          </Link>
        )}
      </li>
    </>
  )

  return (
    <nav className='navbar'>
      <div className='navbar-container'>
        <div className='navbar-logo'>
          <Link to='/'>
            <img src='/logo.png' alt='Runless Logo' className='logo-image' />
            <div className='logo-text'>
              <span className='logo-main'>Runless</span>
              <span className='logo-subtitle'>{t('branding.byCloudSoft')}</span>
            </div>
          </Link>
        </div>

        {isDocsPage ? (
          <ul className='navbar-menu'>{renderDocsMenu()}</ul>
        ) : (
          <ul className='navbar-menu'>{renderLandingMenu()}</ul>
        )}

        <div className='navbar-actions'>
          {isAuthenticated ? (
            <>
              <Link to='/dashboard' className='btn btn-text'>
                Dashboard
              </Link>
              <button type='button' className='btn btn-secondary' onClick={() => logout()}>
                Sign out
              </button>
            </>
          ) : (
            <button type='button' className='btn btn-primary' onClick={() => login('/dashboard')}>
              {t('nav.login')}
            </button>
          )}
        </div>

        <button
          type='button'
          className='navbar-mobile-toggle'
          aria-label='Toggle navigation menu'
          aria-expanded={isMobileMenuOpen}
          onClick={() => setIsMobileMenuOpen(prev => !prev)}
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      <div className={`navbar-mobile-menu ${isMobileMenuOpen ? 'is-open' : ''}`}>
        <ul>{isDocsPage ? renderDocsMenu() : renderLandingMenu()}</ul>
      </div>
    </nav>
  )
}

export default Navigation
